module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Users","newUser":"New User","modal":{"newUserTitle":"New User","userDetailsTitle":"User details","cancel":"Cancel"}},"hr":{"title":"Korisnici","newUser":"Novi korisnik","modal":{"newUserTitle":"Novi korisnik","userDetailsTitle":"Detalji korisnika","cancel":"Odustani"}}}')
  delete Component.options._Ctor
}
